import * as React from 'react';
import { AppBar, SvgIcon, CssBaseline, Divider, GlobalStyles, Grid, Stack, Toolbar, Typography, Box, Button } from '@mui/material';
import Footer from './components/Footer';
import { Link, useNavigate } from "react-router-dom";

export default function Main({props}) {
      const navigate = useNavigate();
    const [address, setAddress] = React.useState(null)
    const [list, setList] = React.useState(null);

    const location=()=>{
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(success, error, {maximumAge:60000, timeout:5000, enableHighAccuracy:true});
        }else{
            console.log("Geolocation is not supported by this browser.");
        }
    }
      
    function success(position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;

        const queryParams = {
            latlng: `${latitude}, ${longitude}`,
            key:"AIzaSyA12JeQMiuUtxPYUtZLH144k-0Yyo9m23I"
        }

        getAddress(queryParams).then((response)=>{
            if(response.status == 200){
                console.log(response.data[6])
                setAddress(response.data[6])
            }else{
                console.log(response.message)
            }
        })
    }
  
    function error(err) {
        console.warn(`ERROR(${err.code}): ${err.message}`);
    }

    React.useEffect(() => {
        location()
    }, [])


    const getAddress = async(queryParams)=>{
        try{
            const params = new URLSearchParams(queryParams).toString()
            const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?`+params, {
                method: "GET"
            })
            const json = await response.json()
            return {data: json.results, status: response.status, message: json.message}
        }catch(error){
            return {data: null, status: 400, message: error.message}
        }
    } 

  return (
    <Stack>
        {/* Header */}
        <CssBaseline></CssBaseline>
        <AppBar position="fixed">
            <Toolbar>
                <Link to="/home" style={{ textDecoration: 'none' }}>
                    <img
                    src="https://firebasestorage.googleapis.com/v0/b/xpediente-clinico.appspot.com/o/logos%2Fcardex_medico_logo.png?alt=media&token=0ba70358-0587-41a6-a5cf-367f17fe8ac4"
                    alt="Cardex Médico"
                    style={{ width: 128, height: 64, cursor: 'pointer' }}
                    />
                </Link>
            <Box
                variant="h6"
                component="div"
                sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
            >
            </Box>
                <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                    {[{name:"Login",route:"/login"}, {name:"Registro",route:"/registry"}].map((item) => (
                        <Button key={item.name} onClick={() => navigate(item.route)}>
                            {item.name}
                        </Button>
                    ))}
                </Box>
            </Toolbar>
        </AppBar>  
      
        {props}
        
        {/* Footer */}
        <Footer></Footer>
        {/* End footer */}
    </Stack>
  );
}